import React, { useEffect } from 'react';
import styled from 'styled-components';

import { SmallLoader } from 'shared/components';
import useDispensary from 'src/dispensary/hooks/use-dispensary';

import { detectLoyaltyIntegration, useLoyalty, Statuses } from 'src/components/loyalty/use-loyalty';
import { Connect } from 'src/components/loyalty/connect';
import { Terms } from 'src/components/loyalty/terms';
import { DposMyReferral } from 'src/components/loyalty/rewards/dpos-referrals';
import { useDposLoyalty } from '../../dpos-loyalty-context';

export const ReferralsPanel = (): JSX.Element => {
  const { dispensary } = useDispensary();
  const loyaltyProgram = detectLoyaltyIntegration(dispensary);
  const { status, setStatus, programName, programDescription, createUserAndPin } = useLoyalty({
    initialStatus: Statuses.loading,
    integration: loyaltyProgram,
    surface: 'referralsPanel',
  });

  const { referral, referralConfig, isLoyaltyMember, loyaltyRequireOptIn, loading } = useDposLoyalty();

  useEffect(() => {
    if (!loading) {
      setStatus(!isLoyaltyMember && loyaltyRequireOptIn ? Statuses.signup : Statuses.success);
    }
  }, [isLoyaltyMember, loyaltyRequireOptIn, loading, setStatus]);

  return (
    <>
      {status === Statuses.loading && <SmallLoader data-testid='small-loader' />}

      {status === Statuses.signup && (
        <Connect setStatus={setStatus} programName={programName} programDescription={programDescription} />
      )}

      {status === Statuses.terms && (
        <Terms setStatus={setStatus} createUserAndPin={createUserAndPin} programName={programName} />
      )}

      {status === Statuses.success && referral && (
        <ReferralsPanelContainer>
          <DposMyReferral referral={referral} referralConfiguration={referralConfig ?? undefined} hideBorder />
        </ReferralsPanelContainer>
      )}
    </>
  );
};

const ReferralsPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 50px;
`;
